import { deepEqual } from 'rxdb/plugins/utils';

export const UNSYNCED_REASONS = {
  NEVER_SYNCED: 'never_synced',
  LOCAL_AHEAD: 'local_ahead',
  SERVER_AHEAD: 'server_ahead'
};

export function toTimestampMs(value) {
  if (value === null || value === undefined) {
    return null;
  }

  return typeof value === 'number' ? value : new Date(value).getTime();
}

export function applyServerUpdatedAt(doc, isoOrMs) {
  const serverMs = toTimestampMs(isoOrMs);

  doc.lastSyncedAt = serverMs;
  doc.updatedAt = serverMs;

  return doc;
}

export function stampLocalUpdatedAt(plainData) {
  plainData.updatedAt = Date.now();

  return plainData;
}

export function isSynced(doc) {
  if (doc === null || doc === undefined) {
    return false;
  }

  const { updatedAt, lastSyncedAt } = doc;

  if (lastSyncedAt === null || lastSyncedAt === undefined) {
    return false;
  }

  if (updatedAt === null || updatedAt === undefined) {
    return false;
  }

  return updatedAt === lastSyncedAt;
}

export function unsyncedReason(doc) {
  if (doc === null || doc === undefined || isSynced(doc)) {
    return null;
  }

  if (doc.lastSyncedAt === null || doc.lastSyncedAt === undefined) {
    return UNSYNCED_REASONS.NEVER_SYNCED;
  }

  if (doc.updatedAt === null || doc.updatedAt === undefined) {
    return null;
  }

  if (doc.updatedAt > doc.lastSyncedAt) {
    return UNSYNCED_REASONS.LOCAL_AHEAD;
  }

  return UNSYNCED_REASONS.SERVER_AHEAD;
}

const METADATA_KEYS = [
  'updatedAt',
  'lastSyncedAt',

  // these are rxdb fields
  '_meta',
  '_attachments'
];

export function shouldTrackUpdate(previous, next) {
  return [...new Set([...Object.keys(previous), ...Object.keys(next)])].some(
    key => !METADATA_KEYS.includes(key) && !deepEqual(previous[key], next[key])
  );
}

export function migrateTimestampsFromLegacyUpdatedAt(oldDoc) {
  if (oldDoc.updatedAt !== null && oldDoc.updatedAt !== undefined) {
    oldDoc.lastSyncedAt = oldDoc.updatedAt;
  } else {
    oldDoc.updatedAt = Date.now();
  }

  return oldDoc;
}
